module.exports = function (e) {
  var t = {};
  function a(n) {
    if (t[n]) return t[n].exports;
    var r = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(r.exports, r, r.exports, a), r.l = !0, r.exports;
  }
  return a.m = e, a.c = t, a.d = function (e, t, n) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (e, t) {
    if (1 & t && (e = a(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (a.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) a.d(n, r, function (t) {
      return e[t];
    }.bind(null, r));
    return n;
  }, a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, "a", t), t;
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.p = "/dist/", a(a.s = 9);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t) {
  e.exports = require("react-final-form");
}, function (e, t, a) {
  "use strict";

  a.d(t, "f", function () {
    return f;
  }), a.d(t, "e", function () {
    return p;
  }), a.d(t, "b", function () {
    return b;
  }), a.d(t, "d", function () {
    return y;
  }), a.d(t, "c", function () {
    return h;
  }), a.d(t, "g", function () {
    return C;
  }), a.d(t, "a", function () {
    return F;
  });
  var n = a(1),
    r = a.n(n),
    l = ["primary", "secondary", "tertiary", "quaternary", "light", "dark"],
    c = ["success", "error", "warning", "info", "disabled", "active", "show", "hide", "hidden"],
    i = ["full", "half", "third", "quarter", "eight"],
    o = ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"],
    s = ["hollow", "pill"];
  function m(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function u(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var d = function (e, t) {
      var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return e.filter(function (e) {
        return void 0 !== t[e];
      }).reduce(function (e, a) {
        return e[a] = t[a], e;
      }, a);
    },
    f = function (e) {
      return d(["id", "style", "placeholder", "value", "role", "title", "alt", "tabIndex", "onClick", "onKeyUp", "onKeyDown", "onKeyPress"], e);
    },
    p = function (e) {
      var t = f(e);
      return d(["disabled", "focus", "type", "htmlFor", "onChange", "onInput", "onFocus"], e, t);
    },
    b = function (e) {
      var t = e.className,
        a = e.color,
        n = e.state,
        r = e.size,
        m = e.border,
        u = e.text,
        d = e.bg,
        f = Object.keys(e),
        p = c,
        b = o,
        E = i,
        y = s,
        h = l.concat(p, b, E, y);
      a && f.push(a), n && f.push(n), r && f.push(r);
      var v = h.filter(function (e) {
        return f.includes(e);
      });
      return u && v.push("text-".concat(u)), m && v.push("border-".concat(m)), d && v.push("bg-".concat(d)), "".concat(t || "", " ").concat(v.join(" ")).trim();
    },
    E = function () {
      return {
        id: r.a.string,
        role: r.a.string,
        title: r.a.string,
        alt: r.a.string,
        onClick: r.a.func,
        onKeyUp: r.a.func,
        onKeyDown: r.a.func,
        onKeyPress: r.a.func
      };
    },
    y = function () {
      return function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? m(Object(a), !0).forEach(function (t) {
            u(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : m(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }
        return e;
      }({}, E(), {
        disabled: r.a.bool,
        focus: r.a.bool,
        tabIndex: r.a.oneOfType([r.a.number, r.a.string]),
        type: r.a.string,
        htmlFor: r.a.string,
        onChange: r.a.func,
        onInput: r.a.func
      });
    },
    h = function () {
      var e = c,
        t = o,
        a = i,
        n = s,
        m = l.concat(e, t, a, n).reduce(function (e, t) {
          return e[t] = r.a.bool, e;
        }, {});
      Object.assign(m, {
        color: r.a.string,
        state: r.a.string,
        size: r.a.string,
        text: r.a.string,
        border: r.a.string,
        bg: r.a.string
      });
    },
    v = a(0),
    g = a(6),
    N = a.n(g);
  function O(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || j(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function w(e) {
    return function (e) {
      if (Array.isArray(e)) return S(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || j(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function j(e, t) {
    if (e) {
      if ("string" == typeof e) return S(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(a) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? S(e, t) : void 0;
    }
  }
  function S(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  function k(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function x(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? k(Object(a), !0).forEach(function (t) {
        A(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : k(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }
  function A(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var P = function (e, t) {
      var a = e.unSorted,
        n = e.disabled;
      switch (t.type) {
        case "SET_UNSORTED":
          return x({}, e, {
            unSorted: x({}, t.payload)
          });
        case "TOGGLE_DISABLE_SORT":
          return x({}, e, {
            disabled: !n
          });
        case "SORT":
          for (var r = w(t.payload), l = []; r.length;) {
            var c = r.shift();
            l.push(a[c]);
          }
          return x({}, e, {
            sorted: l
          });
        default:
          throw new Error("Unknown Action type");
      }
    },
    C = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        a = arguments.length > 2 ? arguments[2] : void 0,
        n = {
          unSorted: x({}, t),
          sorted: [],
          disabled: !1
        },
        r = Object(v.useReducer)(P, n),
        l = O(r, 2),
        c = l[0],
        i = l[1],
        o = c.sorted,
        s = c.unSorted,
        m = c.disabled,
        u = Object(v.useCallback)(function () {
          var t = Array.from(e.current.children).map(function (e) {
            return e.getAttribute("handle");
          });
          i({
            type: "SORT",
            payload: t
          });
        }, [e]);
      Object(v.useEffect)(function () {
        e.current && (c.sortable || (c.sortable = N.a.create(e.current, {
          swapThreshold: .66,
          swap: !0,
          swapClass: "highlight",
          animation: 150,
          onEnd: u
        })));
      }, [u, e, c.sortable]), Object(v.useEffect)(function () {
        c.sortable.option("disabled", m);
      }, [m, c.sortable]), Object(v.useEffect)(function () {
        t.length === Object.values(s).length || m || i({
          type: "SET_UNSORTED",
          payload: t
        });
      }, [m, t, s]), Object(v.useEffect)(function () {
        a && o.length > 1 && a(o);
      }, [o, a]);
      var d = function () {
        return i({
          type: "TOGGLE_DISABLE_SORT"
        });
      };
      return {
        sorted: o,
        toggleDisabled: d,
        disabled: m,
        sortable: c.sortable
      };
    },
    F = function (e) {
      return "string" != typeof e ? "" : e.charAt(0).toUpperCase() + e.slice(1);
    };
}, function (e, t) {
  e.exports = require("filestack-react");
}, function (e, t, a) {
  "use strict";

  (function (e) {
    a.d(t, "a", function () {
      return m;
    });
    var n = a(0),
      r = a.n(n),
      l = a(4),
      c = a.n(l),
      i = a(3);
    function o(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var a = [],
          n = !0,
          r = !1,
          l = void 0;
        try {
          for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
        } catch (e) {
          r = !0, l = e;
        } finally {
          try {
            n || null == i.return || i.return();
          } finally {
            if (r) throw l;
          }
        }
        return a;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return s(e, t);
        var a = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === a && e.constructor && (a = e.constructor.name);
        if ("Map" === a || "Set" === a) return Array.from(a);
        if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return s(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function s(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
      return n;
    }
    var m = function (t) {
      var a = t.type,
        l = void 0 === a ? "multiple" : a,
        s = t.profilePicture,
        m = void 0 === s ? null : s,
        u = t.gallery,
        d = void 0 === u ? [] : u,
        f = t.onSave,
        p = t.onDelete,
        b = t.onSorted,
        E = Object(n.useRef)(null),
        y = o(Object(n.useState)([]), 2),
        h = y[0],
        v = y[1];
      Object(i.g)(E, d, function (e) {
        v(e);
      }), Object(n.useEffect)(function () {
        "multiple" === l && b && b(h);
      }, [h, b, l]);
      var g = function () {
          return m ? r.a.createElement("div", {
            className: "image-container"
          }, r.a.createElement("img", {
            src: m,
            alt: ""
          }), r.a.createElement("a", {
            onClick: p,
            className: "close"
          }, r.a.createElement("i", {
            className: "fal fa-times-circle"
          }))) : r.a.createElement("div", {
            className: "image-container"
          }, r.a.createElement("img", {
            src: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png",
            alt: ""
          }));
        },
        N = function () {
          return d.map(function (e, t) {
            return r.a.createElement("div", {
              key: t,
              handle: t,
              className: "image-container"
            }, r.a.createElement("img", {
              src: e,
              alt: ""
            }), r.a.createElement("a", {
              onClick: function () {
                return p(e);
              },
              className: "close"
            }, r.a.createElement("i", {
              className: "fal fa-times-circle"
            })));
          });
        };
      return r.a.createElement("div", {
        className: "image-picker"
      }, r.a.createElement("div", {
        className: "header"
      }, r.a.createElement("h5", null, "single" === l ? "Profile picture" : "Gallery", ":"), "single" === l ? r.a.createElement(c.a, {
        apikey: e.env.ZENCARE_FILESTACK_API_KEY,
        actionOptions: {
          maxFiles: 1
        },
        onSuccess: f,
        componentDisplayMode: {
          customText: "Upload new profile picture",
          customClass: "primary sm"
        }
      }) : r.a.createElement(c.a, {
        apikey: e.env.ZENCARE_FILESTACK_API_KEY,
        actionOptions: {
          maxFiles: 20
        },
        onSuccess: f,
        componentDisplayMode: {
          customText: "Upload new gallery images",
          customClass: "primary sm"
        }
      })), r.a.createElement("div", {
        className: "gallery",
        ref: E
      }, "single" === l ? g() : N()));
    };
  }).call(this, a(10));
}, function (e, t) {
  e.exports = require("sortablejs");
}, function (e, t) {
  e.exports = require("chart.js");
}, function (e, t) {
  e.exports = require("nouislider");
}, function (e, t, a) {
  e.exports = a(11);
}, function (e, t) {
  var a,
    n,
    r = e.exports = {};
  function l() {
    throw new Error("setTimeout has not been defined");
  }
  function c() {
    throw new Error("clearTimeout has not been defined");
  }
  function i(e) {
    if (a === setTimeout) return setTimeout(e, 0);
    if ((a === l || !a) && setTimeout) return a = setTimeout, setTimeout(e, 0);
    try {
      return a(e, 0);
    } catch (t) {
      try {
        return a.call(null, e, 0);
      } catch (t) {
        return a.call(this, e, 0);
      }
    }
  }
  !function () {
    try {
      a = "function" == typeof setTimeout ? setTimeout : l;
    } catch (e) {
      a = l;
    }
    try {
      n = "function" == typeof clearTimeout ? clearTimeout : c;
    } catch (e) {
      n = c;
    }
  }();
  var o,
    s = [],
    m = !1,
    u = -1;
  function d() {
    m && o && (m = !1, o.length ? s = o.concat(s) : u = -1, s.length && f());
  }
  function f() {
    if (!m) {
      var e = i(d);
      m = !0;
      for (var t = s.length; t;) {
        for (o = s, s = []; ++u < t;) o && o[u].run();
        u = -1, t = s.length;
      }
      o = null, m = !1, function (e) {
        if (n === clearTimeout) return clearTimeout(e);
        if ((n === c || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);
        try {
          n(e);
        } catch (t) {
          try {
            return n.call(null, e);
          } catch (t) {
            return n.call(this, e);
          }
        }
      }(e);
    }
  }
  function p(e, t) {
    this.fun = e, this.array = t;
  }
  function b() {}
  r.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var a = 1; a < arguments.length; a++) t[a - 1] = arguments[a];
    s.push(new p(e, t)), 1 !== s.length || m || i(f);
  }, p.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = b, r.addListener = b, r.once = b, r.off = b, r.removeListener = b, r.removeAllListeners = b, r.emit = b, r.prependListener = b, r.prependOnceListener = b, r.listeners = function (e) {
    return [];
  }, r.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, r.cwd = function () {
    return "/";
  }, r.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, r.umask = function () {
    return 0;
  };
}, function (e, t, a) {
  "use strict";

  a.r(t), a.d(t, "Breadcrumbs", function () {
    return i;
  }), a.d(t, "Button", function () {
    return f;
  }), a.d(t, "Card", function () {
    return b;
  }), a.d(t, "Dropdown", function () {
    return P;
  }), a.d(t, "Input", function () {
    return S;
  }), a.d(t, "AvailabilityUpdates", function () {
    return T;
  }), a.d(t, "AccountPreferences", function () {
    return _;
  }), a.d(t, "CustomItems", function () {
    return L;
  }), a.d(t, "ImagePicker", function () {
    return R.a;
  }), a.d(t, "Author", function () {
    return $;
  }), a.d(t, "Avatar", function () {
    return J;
  }), a.d(t, "ClusterMenu", function () {
    return K;
  }), a.d(t, "Filters", function () {
    return fe;
  }), a.d(t, "Footer", function () {
    return Ee;
  }), a.d(t, "Pagination", function () {
    return ye;
  }), a.d(t, "PhoneConsultationTimes", function () {
    return he;
  }), a.d(t, "ProviderList", function () {
    return je;
  }), a.d(t, "Switch", function () {
    return Se;
  }), a.d(t, "Table", function () {
    return ke;
  }), a.d(t, "Tabs", function () {
    return Pe;
  }), a.d(t, "Tag", function () {
    return ve;
  }), a.d(t, "Testimonial", function () {
    return Ce;
  }), a.d(t, "ToolTip", function () {
    return Fe;
  }), a.d(t, "WizardNav", function () {
    return Te;
  }), a.d(t, "LocationView", function () {
    return We;
  }), a.d(t, "EditProfile", function () {
    return Le;
  }), a.d(t, "ReferAFriend", function () {
    return Re;
  }), a.d(t, "Contact", function () {
    return Ve;
  }), a.d(t, "SideNav", function () {
    return Je;
  }), a.d(t, "TopNav", function () {
    return Qe;
  }), a.d(t, "NavLink", function () {
    return Xe;
  }), a.d(t, "NavGroup", function () {
    return nt;
  }), a.d(t, "NavDropdown", function () {
    return it;
  });
  var n = a(0),
    r = a.n(n);
  function l(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return c(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return c(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function c(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var i = function (e) {
      var t = e.links;
      return r.a.createElement("div", {
        className: "breadcrumbs"
      }, Object.entries(t).map(function (e, t) {
        var a = l(e, 2),
          n = a[0],
          c = a[1];
        return r.a.createElement(r.a.Fragment, null, t ? r.a.createElement("i", {
          className: "fas fa-caret-right"
        }) : "", r.a.createElement("a", {
          href: c
        }, n));
      }));
    },
    o = a(1),
    s = a.n(o),
    m = a(3);
  function u(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function d(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var f = function (e) {
    var t = e.children,
      a = Object(m.e)(e);
    return a.className = Object(m.b)(e), r.a.createElement("button", a, t);
  };
  f.propTypes = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? u(Object(a), !0).forEach(function (t) {
        d(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : u(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }({}, Object(m.d)(), {}, Object(m.c)());
  var p = f,
    b = function (e) {
      var t = e.type,
        a = e.children;
      return r.a.createElement("div", {
        className: "card ".concat(t)
      }, a);
    },
    E = b,
    y = function (e) {
      var t = e.item,
        a = t.key,
        n = t.value,
        l = t.text,
        c = e.selected,
        i = e.multiple,
        o = e.onChange;
      return r.a.createElement("div", {
        className: "dropdown-item\n                ".concat(i && "multi-select checkbox", "\n                ").concat(c && !i && "active", "\n                "),
        key: a
      }, r.a.createElement("input", {
        id: a,
        name: a,
        value: n,
        type: "checkbox",
        checked: c,
        onChange: o
      }), r.a.createElement("label", {
        htmlFor: a
      }, l));
    };
  y.propTypes = {
    item: s.a.shape({
      key: s.a.string.isRequired,
      value: s.a.string.isRequired,
      text: s.a.string.isRequired
    }),
    multiple: s.a.bool,
    onChange: s.a.func
  };
  var h = y;
  function v(e) {
    return function (e) {
      if (Array.isArray(e)) return g(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return g(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return g(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function g(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var N = function (e) {
    var t = e.visible,
      a = e.search,
      n = e.options,
      l = e.multiple,
      c = e.toggleVisible,
      i = e.inputValue,
      o = e.selectedOptions,
      s = e.setSelectedOptions,
      m = e.isItemSelected,
      u = e.clearInput,
      d = e.clearAll,
      f = e.onSave,
      b = e.customMenu,
      E = function (e) {
        a && u(""), l ? g(e) : y(e);
      },
      y = function (e) {
        s([e.target.value]), c(!1);
      },
      g = function (e) {
        N(e.target.value) ? s(O(e)) : s([].concat(v(o), [e.target.value]));
      },
      N = function (e) {
        return o.includes(e);
      },
      O = function (e) {
        return o.filter(function (t) {
          return t !== e.target.value;
        });
      },
      w = i.toLowerCase(),
      j = n.filter(function (e) {
        var t = e.text.toLowerCase();
        return e.text.toLowerCase().includes(w) || function (e, t) {
          var a = t.split("").map(function (e) {
              return "(?=.*".concat(e, ")");
            }),
            n = new RegExp("".concat(a), "g");
          return e.match(n);
        }(t, w);
      }),
      S = function (e) {
        return b || r.a.createElement("div", {
          className: "options"
        }, e.map(function (e) {
          return r.a.createElement(h, {
            key: e.key,
            item: e,
            multiple: l,
            selected: m(e),
            onChange: E
          });
        }));
      };
    return t ? r.a.createElement("div", {
      className: "dropdown-menu ".concat(b ? "budget" : "")
    }, S(a ? j : n), function () {
      if (l && (d || f)) return r.a.createElement("div", {
        className: "footer"
      }, d && r.a.createElement(p, {
        onClick: function () {
          return s([]);
        },
        hollow: !0,
        primary: !0,
        sm: !0
      }, "Clear"), f && r.a.createElement(p, {
        onClick: function () {
          c(!1), f();
        },
        primary: !0,
        sm: !0
      }, "Save"));
    }()) : null;
  };
  N.propTypes = {
    visible: s.a.bool.isRequired,
    options: s.a.array.isRequired,
    selectedOptions: s.a.array.isRequired,
    setSelectedOptions: s.a.func.isRequired,
    isItemSelected: s.a.func.isRequired,
    clearInput: s.a.func,
    search: s.a.bool,
    multiple: s.a.bool,
    toggleVisible: s.a.func,
    inputValue: s.a.string,
    onChange: s.a.func,
    customMenu: s.a.element
  };
  var O = N;
  function w(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function j(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var S = function (e) {
    var t = Object(m.e)(e);
    return t.className = Object(m.b)(e), r.a.createElement(r.a.Fragment, null, r.a.createElement("input", t), e.icon_right);
  };
  S.propTypes = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? w(Object(a), !0).forEach(function (t) {
        j(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : w(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }({}, Object(m.d)());
  var k = S;
  function x(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return A(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return A(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function A(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var P = function (e) {
    var t = e.options,
      a = void 0 === t ? [] : t,
      l = e.placeholder,
      c = e.search,
      i = e.multiple,
      o = e.onChange,
      s = e.clearAll,
      m = e.onSave,
      u = e.customMenu,
      d = e.className,
      f = x(Object(n.useState)(!1), 2),
      p = f[0],
      b = f[1],
      E = x(Object(n.useState)(""), 2),
      y = E[0],
      h = E[1],
      v = x(Object(n.useState)([]), 2),
      g = v[0],
      N = v[1];
    Object(n.useEffect)(function () {
      o && o(g);
    }, [g, o]);
    var w = Object(n.useRef)(),
      j = function (e) {
        w.current.contains(e.target) || b(!1);
      };
    Object(n.useEffect)(function () {
      return document.addEventListener("mousedown", j), function () {
        document.removeEventListener("mousedown", j);
      };
    });
    var S = function (e) {
        return 1 === e ? A() : e > 1 ? C() : l;
      },
      A = function () {
        return a.filter(P)[0].text;
      },
      P = function (e) {
        return g.includes(e.key);
      },
      C = function () {
        return "Selected (".concat(g.length, ")");
      },
      F = function () {
        return p || g.length ? "active" : null;
      };
    return r.a.createElement("div", {
      className: "dropdown ".concat(d),
      ref: w
    }, r.a.createElement("div", {
      className: "header"
    }, c ? r.a.createElement(k, {
      type: "text",
      placeholder: S(g.length),
      className: F(),
      onFocus: function () {
        return b(!0);
      },
      value: y,
      onChange: function (e) {
        return h(e.target.value);
      }
    }) : r.a.createElement("button", {
      onClick: function () {
        return b(!p);
      },
      className: "input ".concat(F())
    }, r.a.createElement("span", {
      className: "".concat(g.length ? "" : "placeholder")
    }, S(g.length))), r.a.createElement("a", {
      onClick: function () {
        return b(!p);
      }
    }, r.a.createElement("i", {
      className: "fal fa-caret-".concat(p ? "up" : "down")
    }))), r.a.createElement(O, {
      visible: p,
      toggleVisible: b,
      inputValue: y,
      search: c,
      options: a,
      multiple: i,
      selectedOptions: g,
      setSelectedOptions: N,
      isItemSelected: P,
      clearInput: h,
      clearAll: s,
      onSave: m,
      customMenu: u
    }));
  };
  P.propTypes = {
    options: s.a.array,
    placeholder: s.a.string.isRequired,
    search: s.a.bool,
    multiple: s.a.bool,
    onChange: s.a.func
  };
  var C = P,
    F = a(2);
  var T = function (e) {
      e.location;
      var t = e.onSubmit,
        a = e.validate;
      return r.a.createElement(F.Form, {
        onSubmit: t,
        validate: a,
        render: function (e) {
          var t = e.handleSubmit;
          e.values;
          return r.a.createElement(r.a.Fragment, null, r.a.createElement(F.FormSpy, {
            subscription: {
              values: !0
            },
            onChange: function (e) {
              Object.keys(e.values).length && t(e);
            }
          }), r.a.createElement("div", {
            className: "tab-container"
          }, r.a.createElement("h5", {
            className: "location-name"
          }, "Are you accepting new clients?")));
        }
      });
    },
    _ = function (e) {
      var t = e.onSubmit,
        a = e.validate;
      return r.a.createElement(F.Form, {
        onSubmit: t,
        validate: a,
        render: function (e) {
          var t = e.handleSubmit;
          e.values;
          return r.a.createElement("div", {
            className: "form portal"
          }, r.a.createElement("div", {
            className: "account-preferences"
          }, r.a.createElement("h4", null, "Account Preferences"), r.a.createElement("h6", null, "Update your credentials below"), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "Current Password"), r.a.createElement(F.Field, {
            name: "password",
            component: "input",
            type: "text"
          })), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "New Password"), r.a.createElement(F.Field, {
            name: "newPassword",
            component: "input",
            type: "text"
          })), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "Confirm New Password"), r.a.createElement(F.Field, {
            name: "confirmNewPassword",
            component: "input",
            type: "text"
          })), r.a.createElement("button", {
            onClick: t,
            className: "primary"
          }, "Submit")));
        }
      });
    },
    D = function (e) {
      var t = e.title,
        a = e.body,
        n = e.onSave,
        l = e.onCancel,
        c = e.onDelete,
        i = e.type,
        o = void 0 === i ? "update" : i;
      return r.a.createElement(F.Form, {
        onSubmit: n,
        render: function (e) {
          var n = e.handleSubmit;
          e.values;
          return r.a.createElement("div", {
            className: "form-container"
          }, r.a.createElement("div", {
            className: "text-input"
          }, r.a.createElement(F.Field, {
            name: "name",
            component: "input",
            initialValue: t
          })), r.a.createElement("div", {
            className: "text-input"
          }, r.a.createElement(F.Field, {
            name: "body",
            component: "textarea",
            initialValue: a
          })), r.a.createElement("div", {
            className: "actions"
          }, r.a.createElement("div", null, r.a.createElement(p, {
            primary: !0,
            onClick: n
          }, "Save"), r.a.createElement(p, {
            primary: !0,
            hollow: !0,
            onClick: l
          }, "Cancel")), "update" === o && r.a.createElement(p, {
            error: !0,
            onClick: c
          }, "Delete")));
        }
      });
    };
  function I(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return B(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return B(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function B(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var M = function (e) {
    var t = e.item,
      a = t.title,
      l = t.body,
      c = e.onSave,
      i = e.onDelete,
      o = e.handle,
      s = I(Object(n.useState)(!1), 2),
      m = s[0],
      u = s[1];
    return m ? r.a.createElement("div", {
      className: "custom-item"
    }, r.a.createElement(D, {
      title: a,
      body: l,
      onCancel: function () {
        return u(!1);
      },
      onDelete: i,
      onSave: c
    })) : r.a.createElement("div", {
      className: "custom-item",
      handle: o
    }, r.a.createElement("div", {
      className: "header"
    }, r.a.createElement("h5", null, a), r.a.createElement(p, {
      primary: !0,
      sm: !0,
      onClick: function () {
        return u(!0);
      }
    }, r.a.createElement("i", {
      className: "fas fa-edit"
    }))), r.a.createElement("p", {
      className: "body"
    }, l));
  };
  function q(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return W(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return W(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function W(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var L = function (e) {
      var t = e.title,
        a = e.items,
        l = e.onSave,
        c = e.onAdd,
        i = e.onDelete,
        o = Object(n.useRef)(null),
        s = q(Object(n.useState)([]), 2),
        u = s[0],
        d = s[1],
        f = q(Object(n.useState)(!1), 2),
        b = f[0],
        E = f[1];
      Object(m.g)(o, a, function (e) {
        d(e);
      });
      return Object(n.useEffect)(function () {
        l(u);
      }, [u, l]), r.a.createElement("div", {
        className: "custom-items"
      }, r.a.createElement("div", {
        className: "header"
      }, r.a.createElement("h4", null, t), r.a.createElement(p, {
        primary: !0,
        onClick: function () {
          return E(!0);
        }
      }, r.a.createElement("i", {
        className: "fas fa-plus"
      }))), r.a.createElement("hr", null), r.a.createElement("div", {
        ref: o,
        className: "items"
      }, a.map(function (e, t) {
        return r.a.createElement(M, {
          handle: t,
          key: a.title,
          item: e,
          onSave: l,
          onDelete: i
        });
      }), b && r.a.createElement(D, {
        onSave: c,
        onCancel: function () {
          return E(!1);
        },
        type: "add"
      })));
    },
    R = a(5);
  function V(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function H(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? V(Object(a), !0).forEach(function (t) {
        U(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : V(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }
  function U(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var J = function (e) {
    var t = e.src,
      a = e.alt,
      n = e.title,
      l = {
        src: t,
        alt: a || n,
        title: n || a
      };
    return l.className = Object(m.b)(H({}, e, {
      className: ["avatar", e.className || ""].join(" ")
    })), r.a.createElement("img", l);
  };
  J.propTypes = H({}, Object(m.c)(), {
    src: s.a.string.isRequired,
    alt: s.a.string,
    title: s.a.string
  });
  var z = J,
    $ = function (e) {
      var t = e.avatar,
        a = e.header,
        n = e.desc;
      return r.a.createElement("div", {
        className: "author"
      }, r.a.createElement(z, t), r.a.createElement("div", {
        className: "content"
      }, r.a.createElement("h5", null, a), r.a.createElement("p", null, n)));
    },
    Q = [{
      name: "Anxiety"
    }, {
      name: "Addiction"
    }, {
      name: "LGBTQIA topics"
    }, {
      name: "Mindfulness"
    }, {
      name: "Self-esteem"
    }],
    K = function () {
      return r.a.createElement("div", {
        className: "popup-container"
      }, r.a.createElement("div", {
        className: "popup-bubble-anchor"
      }, r.a.createElement("div", {
        className: "popup-bubble"
      }, r.a.createElement("div", {
        className: "header"
      }, r.a.createElement("span", null, "8 Providers"), r.a.createElement("a", {
        className: "close",
        href: ""
      }, r.a.createElement("i", {
        className: "fal fa-times"
      }))), r.a.createElement("div", {
        className: "cards"
      }, r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe"), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, Q.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })))), r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe"), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, Q.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })))), r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe"), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, Q.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      }))))))));
    },
    G = a(7),
    Z = a.n(G);
  function Y(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return X(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return X(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function X(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var ee = function (e) {
      var t = Object(n.useRef)(null),
        a = Y(Object(n.useState)(), 2),
        l = (a[0], a[1]),
        c = e.data,
        i = (e.highlight, e.domain, {
          labels: c.map(function (e, t) {
            return "$".concat(e.session_fee_ongoing);
          }),
          datasets: [{
            hoverBackgroundColor: "#b1b1b1",
            data: c.map(function (e, t) {
              return e.count;
            })
          }]
        }),
        o = {
          responsive: !0,
          legend: {
            display: !1
          },
          scales: {
            xAxes: [{
              display: !1
            }],
            yAxes: [{
              display: !1,
              ticks: {
                min: 0
              }
            }]
          }
        };
      return Object(n.useEffect)(function () {
        t.current && l(new Z.a(t.current, {
          type: "bar",
          data: i,
          options: o
        }));
      }, [t]), r.a.createElement("canvas", {
        id: "chart",
        ref: t
      });
    },
    te = a(8),
    ae = a.n(te);
  function ne(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return re(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return re(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function re(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var le = function (e) {
    var t = e.data,
      a = Object(n.useRef)(null),
      l = ne(Object(n.useState)([]), 2),
      c = l[0],
      i = l[1],
      o = ne(Object(n.useState)([]), 2),
      s = o[0],
      m = o[1],
      u = ne(Object(n.useState)([]), 2),
      d = (u[0], u[1]),
      f = ne(Object(n.useState)([]), 2),
      p = (f[0], f[1]);
    return Object(n.useEffect)(function () {
      var e = t.slice().sort(function (e, t) {
          return e - t;
        }),
        n = [e[0].session_fee_ongoing, e[e.length - 1].session_fee_ongoing];
      i(n), m(n), d(n), p(n), a.current && ae.a.create(a.current, {
        start: [20, 80],
        connect: !0,
        range: {
          min: 0,
          max: 100
        }
      });
    }, [t]), c ? r.a.createElement("div", {
      className: "slider-container"
    }, r.a.createElement(ee, {
      data: t,
      highlight: s,
      domain: c
    }), r.a.createElement("div", {
      id: "slider",
      ref: a
    }), r.a.createElement("div", {
      className: "slider-inputs"
    }, r.a.createElement("div", {
      className: "field"
    }, r.a.createElement("label", {
      htmlFor: "min-budget-fee",
      className: "min-fee"
    }, "min session fee"), r.a.createElement("div", {
      className: "input-container"
    }, r.a.createElement("span", null, "$"), r.a.createElement("input", {
      id: "min-budget-fee",
      name: "min",
      type: "number",
      min: "0",
      max: "500",
      step: "1"
    }))), r.a.createElement("div", {
      className: "field"
    }, r.a.createElement("label", {
      htmlFor: "max-budget-fee",
      className: "max-fee"
    }, "max session fee"), r.a.createElement("div", {
      className: "input-container"
    }, r.a.createElement("span", null, "$"), r.a.createElement("input", {
      id: "max-budget-fee",
      name: "max",
      type: "number",
      min: "0",
      max: "500",
      step: "1"
    }))))) : r.a.createElement("div", null);
  };
  function ce(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return ie(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return ie(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function ie(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var oe = function (e) {
    var t = e.moreFilters,
      a = e.open,
      l = ce(Object(n.useState)(null), 2),
      c = l[0],
      i = l[1],
      o = ce(Object(n.useState)(null), 2),
      s = o[0],
      m = o[1],
      u = ce(Object(n.useState)(null), 2),
      d = u[0],
      f = u[1],
      p = ce(Object(n.useState)(null), 2),
      b = p[0],
      E = p[1],
      y = window.innerHeight;
    Object(n.useEffect)(function () {
      var e = document.getElementById("website") ? document.getElementById("website").offsetHeight : null,
        t = document.getElementsByClassName("filters")[0].offsetHeight + 20,
        a = document.getElementsByClassName("filters")[0].offsetHeight;
      f(a), i(e), m(t);
    }, []);
    return r.a.createElement("div", {
      className: "more-filters",
      style: {
        height: "".concat(y - (c + s), "px"),
        display: "".concat(a ? "" : "none"),
        paddingBottom: d
      }
    }, r.a.createElement("div", {
      class: "header"
    }, r.a.createElement("div", {
      class: "content"
    }, r.a.createElement("a", {
      class: "close"
    }, r.a.createElement("i", {
      class: "fal fa-times"
    })), r.a.createElement("a", null, r.a.createElement("u", null, "Clear")))), t.map(function (e, t) {
      return r.a.createElement("div", {
        key: t,
        className: "container options"
      }, r.a.createElement("span", {
        className: "title heading-7"
      }, e.title), "Therapy Budget" !== e.title ? r.a.createElement(r.a.Fragment, null, r.a.createElement("ul", null, e.options.map(function (e, a) {
        return a < 6 ? r.a.createElement("li", {
          className: "checkbox",
          key: a
        }, r.a.createElement("input", {
          id: e.key,
          type: "checkbox"
        }), r.a.createElement("label", {
          htmlFor: e.key
        }, r.a.createElement("div", null, e.text))) : r.a.createElement("li", {
          key: a,
          style: {
            display: "".concat(b === t ? "" : "none")
          }
        }, r.a.createElement("input", {
          id: e.key,
          type: "checkbox"
        }), r.a.createElement("label", {
          htmlFor: e.key
        }, r.a.createElement("div", null, r.a.createElement("span", null, e.text))));
      })), e.options.length > 6 && r.a.createElement("button", {
        onClick: function () {
          return E(b === t ? null : t);
        }
      }, (a = t, n = e.options.length, a === b ? r.a.createElement(r.a.Fragment, null, r.a.createElement("span", null, "Hide"), r.a.createElement("i", {
        className: "fal fa-chevron-up"
      })) : r.a.createElement(r.a.Fragment, null, r.a.createElement("span", null, "Show all ", n), r.a.createElement("i", {
        className: "fal fa-chevron-down"
      }))))) : r.a.createElement(le, {
        data: e.options
      }));
      var a, n;
    }), r.a.createElement("h5", null, "Session information filters"), r.a.createElement("div", {
      className: "container options"
    }, r.a.createElement("h6", null, "Appointment Accessibility"), r.a.createElement("ul", null, r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "morning",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "morning"
    }, r.a.createElement("div", null, "Morning"))), r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "afternoon",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "afternoon"
    }, r.a.createElement("div", null, "Afternoon"))))), r.a.createElement("div", {
      className: "container options"
    }, r.a.createElement("h6", null, "Clients providers work with"), r.a.createElement("ul", null, r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "adults",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "adults"
    }, r.a.createElement("div", null, "Adults"))), r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "kids",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "kids"
    }, r.a.createElement("div", null, "Kids"))))), r.a.createElement("div", {
      className: "container options"
    }, r.a.createElement("h6", null, "Approach"), r.a.createElement("ul", null, r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "chairwork",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "chairwork"
    }, r.a.createElement("div", null, "Chairwork"))), r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "drama_therapy",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "drama_therapy"
    }, r.a.createElement("div", null, "Drama therapy"))))), r.a.createElement("div", {
      className: "container options"
    }, r.a.createElement("h6", null, "ADA & online locations"), r.a.createElement("ul", null, r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "ada_accessible_offices",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "ada_accessible_offices"
    }, r.a.createElement("div", null, "ADA Accessible Offices"))), r.a.createElement("li", {
      className: "checkbox"
    }, r.a.createElement("input", {
      id: "online_remote_sessions",
      type: "checkbox"
    }), r.a.createElement("label", {
      htmlFor: "online_remote_sessions"
    }, r.a.createElement("div", null, "Online remote sessions"))))), r.a.createElement("div", {
      className: "footer"
    }, r.a.createElement("div", {
      className: "content"
    }, r.a.createElement("button", {
      className: "reset"
    }, "Reset"), r.a.createElement("button", {
      className: "mobile-save"
    }, "Save"))));
  };
  function se(e) {
    return function (e) {
      if (Array.isArray(e)) return de(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || ue(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function me(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || ue(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function ue(e, t) {
    if (e) {
      if ("string" == typeof e) return de(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(a) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? de(e, t) : void 0;
    }
  }
  function de(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var fe = function (e) {
    var t = e.filters,
      a = me(Object(n.useState)([]), 2),
      l = a[0],
      c = a[1],
      i = me(Object(n.useState)([]), 2),
      o = i[0],
      s = i[1],
      m = me(Object(n.useState)(5), 2),
      u = m[0],
      d = m[1],
      f = me(Object(n.useState)(!1), 2),
      b = f[0],
      E = f[1],
      y = me(Object(n.useState)(window.innerWidth), 2),
      h = y[0],
      v = y[1];
    return Object(n.useEffect)(function () {
      var e = se(t),
        a = e.splice(0, u);
      c(a), s(e);
    }, [t, u]), Object(n.useEffect)(function () {
      var e = window.innerWidth;
      v(window.innerWidth), e > 1200 && d(5), 480 < e && e < 1200 && d(3), e < 480 && d(0), window.addEventListener("resize", function () {
        var e = window.innerWidth;
        v(window.innerWidth), e > 1200 && d(5), 768 < e && e < 1200 && d(3), e < 768 && d(0);
      });
    }, []), r.a.createElement("div", {
      className: "filters"
    }, r.a.createElement("span", {
      className: "number-of-therapists"
    }, "300 Therapists"), r.a.createElement("div", {
      className: "input-containers"
    }, l.map(function (e, t) {
      return "Therapy Budget" === e.title ? r.a.createElement(C, {
        key: e.title,
        placeholder: e.title,
        customMenu: r.a.createElement(le, {
          data: e.options
        })
      }) : r.a.createElement(C, {
        key: e.title,
        placeholder: e.title,
        options: e.options,
        search: !0,
        multiple: !0,
        clearAll: !0
      });
    }), r.a.createElement(p, {
      hollow: !0,
      primary: !0,
      className: "more",
      onClick: function () {
        return E(!b);
      }
    }, "".concat(h < 768 ? "Filters" : "More")), r.a.createElement(oe, {
      open: b,
      moreFilters: o
    })));
  };
  fe.propTypes = {};
  function pe(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return be(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return be(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function be(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var Ee = function (e) {
    var t = e.type,
      a = e.title,
      n = e.resources,
      l = e.social_media,
      c = e.emergency,
      i = new Date().getFullYear();
    return r.a.createElement("footer", {
      id: t
    }, a && r.a.createElement(r.a.Fragment, null, r.a.createElement("h5", {
      className: "title"
    }, a), r.a.createElement("hr", null)), n && r.a.createElement(r.a.Fragment, null, r.a.createElement("div", {
      className: "resources-container"
    }, r.a.createElement("div", {
      className: "left"
    }, Object.entries(n).map(function (e) {
      var t = pe(e, 2),
        a = t[0],
        n = t[1];
      return r.a.createElement("div", {
        key: a,
        className: "resource"
      }, r.a.createElement("h6", {
        className: "resource-title"
      }, a), r.a.createElement("ul", null, Object.entries(n).map(function (e) {
        var t = pe(e, 2),
          a = t[0],
          n = t[1];
        return r.a.createElement("li", {
          key: a
        }, r.a.createElement("a", {
          href: n
        }, a));
      })));
    })), r.a.createElement("div", {
      className: "right"
    }, l && r.a.createElement("div", {
      className: "resource social"
    }, r.a.createElement("h6", {
      className: "resource-title"
    }, "Social media"), r.a.createElement("ul", null, l.facebook && r.a.createElement("li", null, r.a.createElement("a", {
      href: l.facebook
    }, r.a.createElement("i", {
      className: "fab fa-facebook-f"
    }))), l.instagram && r.a.createElement("li", null, r.a.createElement("a", {
      href: l.instagram
    }, r.a.createElement("i", {
      className: "fab fa-instagram"
    }))), l.twitter && r.a.createElement("li", null, r.a.createElement("a", {
      href: l.twitter
    }, r.a.createElement("i", {
      className: "fab fa-twitter"
    }))))), "blog" === t && r.a.createElement("div", {
      className: "resource newsletter"
    }, r.a.createElement("small", null, "Subscribe to our newsletter"), r.a.createElement("form", {
      action: "https://zencare.us11.list-manage.com/subscribe/post?u=36ebe1d4bf0d39ffd0e2d44e6&id=878b9aa18b",
      method: "post",
      id: "mc-embedded-subscribe-form",
      name: "mc-embedded-subscribe-form",
      className: "validate",
      target: "_blank",
      novalidate: !0
    }, r.a.createElement("input", {
      type: "email",
      name: "EMAIL",
      className: "required email",
      id: "mce-EMAIL",
      placeholder: "name@email.com"
    }), r.a.createElement("button", {
      type: "submit"
    }, r.a.createElement("i", {
      className: "fal fa-arrow-right"
    }))))))), c && r.a.createElement("div", {
      className: "emergency"
    }, r.a.createElement("span", null, "If you are in a life threatening situation, don’t use this site. Call the 24h National Suicide Prevention Lifeline at", " "), r.a.createElement("a", {
      href: "#"
    }, "1 (800) 273-8255 "), r.a.createElement("span", null, "or use "), r.a.createElement("a", {
      href: "/about/immediate-help"
    }, "these resources. "), r.a.createElement("span", null, "If your issue is an emergency, call "), r.a.createElement("a", {
      href: "#"
    }, "911 "), r.a.createElement("span", null, "or go to your nearest emergency room.")), "admin" === t && r.a.createElement("div", {
      className: "help"
    }, r.a.createElement("span", null, "If you are experiencing issues, contact the", " ", r.a.createElement("a", {
      href: "mailto:support@zencare.co"
    }, "Zencare Team."))), r.a.createElement("p", {
      className: "copyright"
    }, "© ", i, " Zencare Group, Inc."));
  };
  Ee.propTypes = {
    type: s.a.string.isRequired,
    title: s.a.string,
    resources: s.a.object,
    social_media: s.a.object,
    emergency: s.a.bool
  };
  var ye = function () {
      return r.a.createElement("pagination", {
        className: "pagination"
      }, r.a.createElement("button", {
        className: "primary sm hollow previous",
        disabled: "disabled"
      }, r.a.createElement("i", {
        className: "fas fa-chevron-left"
      })), r.a.createElement("div", {
        className: "page-numbers"
      }, r.a.createElement("div", {
        className: "page-number active"
      }, "1"), r.a.createElement("div", {
        className: "page-number"
      }, "2"), r.a.createElement("div", {
        className: "page-number"
      }, "3"), r.a.createElement("div", {
        className: "page-number"
      }, "4"), r.a.createElement("div", {
        className: "page-number"
      }, "5"), r.a.createElement("div", {
        className: "page-number"
      }, "6"), r.a.createElement("div", {
        className: "page-number"
      }, "7"), r.a.createElement("div", {
        className: "page-number"
      }, "8"), r.a.createElement("div", {
        className: "page-number"
      }, "9"), r.a.createElement("div", {
        className: "page-number"
      }, "10"), r.a.createElement("div", {
        className: "page-number"
      }, "11")), r.a.createElement("button", {
        className: "primary sm hollow next"
      }, r.a.createElement("i", {
        className: "fas fa-chevron-right"
      })));
    },
    he = function () {
      return r.a.createElement(F.Form, {
        onSubmit: function () {
          return console.log("Dope");
        },
        validate: function () {
          return console.log("validate");
        },
        render: function (e) {
          e.handleSubmit;
          return r.a.createElement("div", {
            className: "phone-consultation-times"
          }, r.a.createElement("h4", {
            className: "header"
          }, "Broadway"), r.a.createElement("div", {
            className: "container"
          }, r.a.createElement("div", {
            className: "sub-header"
          }, r.a.createElement("h5", null, "Phone Consultation Times"), r.a.createElement("span", {
            className: "desc"
          }, "Times when you can request to schedule an initial call with you. You can contact the client directly to reschedule.")), r.a.createElement("div", {
            className: "inputs"
          }, r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Monday"), r.a.createElement(F.Field, {
            name: "monday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })), r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Tuesday"), r.a.createElement(F.Field, {
            name: "tuesday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })), r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Wednesday"), r.a.createElement(F.Field, {
            name: "wednesday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })), r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Thursday"), r.a.createElement(F.Field, {
            name: "thursday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })), r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Friday"), r.a.createElement(F.Field, {
            name: "friday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })), r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Saturday"), r.a.createElement(F.Field, {
            name: "saturday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })), r.a.createElement("div", {
            className: "input-container"
          }, r.a.createElement("label", null, "Sunday"), r.a.createElement(F.Field, {
            name: "sunday",
            component: "input",
            placeholder: "e.g. 9-10am, 7:30-8pm"
          })))));
        }
      });
    },
    ve = function (e) {
      var t = e.icon,
        a = e.text,
        n = e.color;
      return r.a.createElement("div", {
        className: "tag ".concat(n)
      }, r.a.createElement("span", {
        className: "container"
      }, t && r.a.createElement("i", {
        className: t
      }), r.a.createElement("span", null, a)));
    },
    ge = ve;
  function Ne(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Oe(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return Oe(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Oe(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var we = [{
      name: "Anxiety"
    }, {
      name: "Addiction"
    }, {
      name: "LGBTQIA topics"
    }, {
      name: "Mindfulness"
    }, {
      name: "Self-esteem"
    }],
    je = function () {
      var e = Ne(Object(n.useState)(null), 2),
        t = e[0],
        a = e[1];
      return Object(n.useEffect)(function () {
        var e = document.getElementsByClassName("filters")[0] ? document.getElementsByClassName("filters")[0].offsetHeight + 20 : null;
        a(e);
      }, []), r.a.createElement("div", {
        style: {
          marginTop: t
        },
        className: "providerList"
      }, r.a.createElement("div", {
        className: "section"
      }, r.a.createElement("div", {
        className: "section-header in-network"
      }, r.a.createElement("div", {
        className: "icon-container"
      }, r.a.createElement("i", {
        className: "fal fa-check-circle"
      })), r.a.createElement("div", {
        className: "text-container"
      }, r.a.createElement("span", {
        className: "title"
      }, "In-network providers"), r.a.createElement("span", {
        className: "description"
      }, "These providers do not have any appointment openings at this time"))), r.a.createElement("div", {
        className: "card-list"
      }, r.a.createElement("a", {
        className: "search card"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))), r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))))), r.a.createElement("div", {
        className: "section"
      }, r.a.createElement("div", {
        className: "section-header within-budget"
      }, r.a.createElement("div", {
        className: "icon-container"
      }, r.a.createElement("i", {
        className: "fal fa-usd-circle"
      })), r.a.createElement("div", {
        className: "text-container"
      }, r.a.createElement("span", {
        className: "title"
      }, "Providers within your budget"), r.a.createElement("span", {
        className: "description"
      }, "These providers do not have any appointment openings at this time"))), r.a.createElement("div", {
        className: "card-list"
      }, r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))), r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))))), r.a.createElement("div", {
        className: "section"
      }, r.a.createElement("div", {
        className: "section-header out-of-budget"
      }, r.a.createElement("div", {
        className: "icon-container"
      }, r.a.createElement("i", {
        className: "fal fa-exclamation-circle"
      })), r.a.createElement("div", {
        className: "text-container"
      }, r.a.createElement("span", {
        className: "title"
      }, "Providers outside your budget"), r.a.createElement("span", {
        className: "description"
      }, "These providers do not have any appointment openings at this time"))), r.a.createElement("div", {
        className: "card-list"
      }, r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))), r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))))), r.a.createElement("div", {
        className: "section"
      }, r.a.createElement("div", {
        className: "section-header out-of-network"
      }, r.a.createElement("div", {
        className: "icon-container"
      }, r.a.createElement("i", {
        className: "fal fa-exclamation-circle"
      })), r.a.createElement("div", {
        className: "text-container"
      }, r.a.createElement("span", {
        className: "title"
      }, "Providers outside your budget"), r.a.createElement("span", {
        className: "description"
      }, "These providers do not have any appointment openings at this time"))), r.a.createElement("div", {
        className: "card-list"
      }, r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))), r.a.createElement(E, {
        type: "search"
      }, r.a.createElement(z, {
        src: "https://images.unsplash.com/photo-1572800578930-fd1013b506c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        border: "grey"
      }), r.a.createElement("div", {
        className: "info"
      }, r.a.createElement("div", {
        className: "align-items"
      }, r.a.createElement("h5", {
        className: "name"
      }, "Jane Doe")), r.a.createElement("div", null, "Social Worker"), r.a.createElement("div", {
        className: "areas"
      }, "Prospect Heights"), r.a.createElement("div", {
        className: "specialties"
      }, we.map(function (e) {
        return r.a.createElement("span", {
          key: e.name,
          className: "specialty"
        }, e.name);
      })), r.a.createElement(ge, {
        text: "Blue Cross Blue Shield",
        color: "primary",
        icon: "fal fa-exclamation-circle"
      }))))));
    },
    Se = function (e) {
      var t = e.isOn,
        a = e.handleToggle,
        n = e.onColor,
        l = e.size;
      return r.a.createElement(r.a.Fragment, null, r.a.createElement("div", {
        className: "switch"
      }, r.a.createElement("input", {
        className: "checkbox",
        checked: t,
        onChange: a,
        id: "react-switch-new",
        type: "checkbox"
      }), r.a.createElement("label", {
        htmlFor: "react-switch-new",
        className: "".concat(t && n, " ").concat(l)
      }, r.a.createElement("span", {
        className: "toggle"
      }))));
    },
    ke = function () {
      return r.a.createElement("table", {
        className: "table"
      }, r.a.createElement("tbody", null, r.a.createElement("tr", null, r.a.createElement("th", {
        className: "empty-cell"
      }), r.a.createElement("th", null, r.a.createElement("img", {
        src: "https://s3.us-east-2.amazonaws.com/zencare/general_site/turquoise_transparent_no_tagline.png",
        alt: "blog"
      })), r.a.createElement("th", null, "Other therapist directories"), r.a.createElement("th", null, "Personal Website")), r.a.createElement("tr", {
        className: "table-section-header"
      }, r.a.createElement("td", {
        colspan: "4"
      }, "Web presence")), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Professional webpage", r.a.createElement("p", {
        className: "table-desc"
      }, "Create a hierarchical menu with expandable submenus, stacked in a vertical column")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Search engine optimization (SEO)", r.a.createElement("p", {
        className: "table-desc"
      }, "Preset menu style options")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Unlimited client referrals via search platform", r.a.createElement("p", {
        className: "table-desc"
      }, "Allow more than one submenu to expand at once")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Custom URL that includes your name", r.a.createElement("p", {
        className: "table-desc"
      }, "Automatically expand the submenu of the current menu item when the page loads")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Professional statement copywriting", r.a.createElement("p", {
        className: "table-desc"
      }, "Add the menu to your site via a shortcode")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-section-header"
      }, r.a.createElement("td", {
        colspan: "4"
      }, "Photos and videos")), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "High quality on-site photoshoot and editing", r.a.createElement("p", {
        className: "table-desc"
      }, "Use the WordPress Customizer to set and preview colors, spacing, and more")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "High quality on-site videoshoot, preparation prompts, and editing", r.a.createElement("p", {
        className: "table-desc"
      }, "Set text and background colors, font sizes and custom spacing for individual menu items")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-section-header"
      }, r.a.createElement("td", {
        colspan: "4"
      }, "Personal customer support")), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Ongoing webpage management", r.a.createElement("p", {
        className: "table-desc"
      }, "Add Font Awesome Icons to your menu items")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Personalized therapist referrals and support for clients", r.a.createElement("p", {
        className: "table-desc"
      }, "Add images to your menu items")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Practice information and availability updated monthly", r.a.createElement("p", {
        className: "table-desc"
      }, "Add widgets to your menu items")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-section-header"
      }, r.a.createElement("td", {
        colspan: "4"
      }, "Community of trusted providers ")), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Professional networking events", r.a.createElement("p", {
        className: "table-desc"
      }, "Create multiple configurations, so you can control and style multiple accordion menus independently")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", null), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Community of vetted therapists", r.a.createElement("p", {
        className: "table-desc"
      }, "Create multiple configurations, so you can control and style multiple accordion menus independently")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", null, r.a.createElement("td", null, "Email listserv of Zencare providers", r.a.createElement("p", {
        className: "table-desc"
      }, "Create multiple configurations, so you can control and style multiple accordion menus independently")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Referral relationships with local hospitals, universities, and wellness communities", r.a.createElement("p", {
        className: "table-desc"
      }, "Automatically generate menu contents based on post or term hierarchies")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-section-header"
      }, r.a.createElement("td", {
        colspan: "4"
      }, "Modern web design and usability")), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Online initial call scheduling tool", r.a.createElement("p", {
        className: "table-desc"
      }, 'Add a "show more" toggle within your submenu to reveal extra menu items')), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      }))), r.a.createElement("tr", {
        className: "table-row"
      }, r.a.createElement("td", null, "Modern search interface and beautiful design", r.a.createElement("p", {
        className: "table-desc"
      }, "Add saved Bellows menus to your site via widget")), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fa fa-check"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })), r.a.createElement("td", null, r.a.createElement("i", {
        className: "fas fa-times"
      })))));
    };
  function xe(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Ae(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return Ae(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Ae(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var Pe = function (e) {
      var t = e.tabs,
        a = xe(Object(n.useState)(0), 2),
        l = a[0],
        c = a[1];
      return r.a.createElement("div", {
        className: "tabs-container"
      }, r.a.createElement("ul", {
        className: "tabs"
      }, t.map(function (e, t) {
        return r.a.createElement("li", {
          onClick: function () {
            return c(t);
          },
          className: "tab ".concat(t === l ? "active" : "")
        }, r.a.createElement("span", null, e.title));
      })), t.map(function (e, t) {
        return r.a.createElement("ul", {
          className: "tab-options",
          style: {
            display: t === l ? "" : "none"
          }
        }, Object.entries(e.options).map(function (e) {
          var t = xe(e, 2),
            a = t[0];
          t[1];
          return r.a.createElement("li", null, r.a.createElement("span", null, a));
        }));
      }));
    },
    Ce = function (e) {
      var t = e.testimonial,
        a = e.credit;
      return r.a.createElement("blockquote", {
        className: "testimonial"
      }, r.a.createElement("i", {
        className: "fas fa-quote-left"
      }), r.a.createElement("p", {
        className: "body"
      }, t), r.a.createElement("p", {
        className: "credit"
      }, "— ", a));
    },
    Fe = function (e) {
      var t = e.color,
        a = e.children,
        n = e.style,
        l = void 0 === n ? {} : n;
      return r.a.createElement("div", {
        className: "tooltip ".concat(t),
        style: l
      }, a);
    },
    Te = function (e) {
      var t = e.children;
      e.selectedTab;
      return r.a.createElement("div", {
        className: "wizard-nav"
      }, t);
    },
    _e = function (e) {
      var t = e.onEdit,
        a = e.onEditValidate,
        n = e.location;
      return r.a.createElement(F.Form, {
        onSubmit: t,
        validate: a,
        render: function (e) {
          var t = e.handleSubmit;
          e.values;
          return r.a.createElement(r.a.Fragment, null, r.a.createElement("div", {
            className: "location-view-form"
          }, r.a.createElement("div", {
            className: "location-hours"
          }, r.a.createElement("div", {
            className: "inputs"
          }, r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "monday_checkbox",
            name: "monday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "monday_checkbox"
          }, "Mon"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "monday",
            component: "input",
            initialValue: n.hours[0]
          })), r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "tuesday_checkbox",
            name: "tuesday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "tuesday_checkbox"
          }, "Tue"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "tuesday",
            component: "input",
            initialValue: n.hours[1]
          })), r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "wednesday_checkbox",
            name: "wednesday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "wednesday_checkbox"
          }, "Wed"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "wednesday",
            component: "input",
            initialValue: n.hours[2]
          })), r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "thursday_checkbox",
            name: "thursday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "thursday_checkbox"
          }, "Thurs"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "thursday",
            component: "input",
            initialValue: n.hours[3]
          })), r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "friday_checkbox",
            name: "friday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "friday_checkbox"
          }, "Fri"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "friday",
            component: "input",
            initialValue: n.hours[4]
          })), r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "saturday_checkbox",
            name: "saturday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "saturday_checkbox"
          }, "Sat"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "saturday",
            component: "input",
            initialValue: n.hours[5]
          })), r.a.createElement("div", {
            className: "input-container checkbox"
          }, r.a.createElement(F.Field, {
            id: "sunday_checkbox",
            name: "sunday_checkbox",
            component: "input",
            type: "checkbox",
            defaultValue: !1
          }), r.a.createElement("label", {
            htmlFor: "sunday_checkbox"
          }, "Sun"), r.a.createElement(F.Field, {
            className: "input-box",
            name: "sunday",
            component: "input",
            initialValue: n.hours[6]
          })))), r.a.createElement("div", {
            className: "actions"
          }, r.a.createElement(p, {
            primary: !0,
            onClick: t
          }, "Submit"))));
        }
      });
    };
  function De(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function Ie(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? De(Object(a), !0).forEach(function (t) {
        Be(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : De(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }
  function Be(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  function Me(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var a = [],
        n = !0,
        r = !1,
        l = void 0;
      try {
        for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (a.push(c.value), !t || a.length !== t); n = !0);
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          n || null == i.return || i.return();
        } finally {
          if (r) throw l;
        }
      }
      return a;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return qe(e, t);
      var a = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === a && e.constructor && (a = e.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(a);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return qe(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function qe(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
    return n;
  }
  var We = function (e) {
      var t = e.location,
        a = e.primaryLocationId,
        l = e.onSubmit,
        c = e.onValidate,
        i = e.onEdit,
        o = e.onEditValidate,
        s = Me(Object(n.useState)(!1), 2),
        u = s[0],
        d = s[1],
        f = Object.entries(t).filter(function (e) {
          var t = Me(e, 2),
            a = t[0];
          t[1];
          return a.includes("availability");
        }).reduce(function (e, t) {
          return e[t[0]] = t[1], e;
        }, {}),
        b = ["ada_accessible", "remote_location", "display_address"],
        E = Object.entries(t).filter(function (e) {
          var t = Me(e, 2),
            a = t[0];
          t[1];
          return b.some(function (e) {
            return a.includes(e);
          });
        }).reduce(function (e, t) {
          return e[t[0]] = t[1], e;
        }, {});
      return r.a.createElement(F.Form, {
        onSubmit: l,
        validate: c,
        render: function (e) {
          var n,
            l,
            c = e.handleSubmit;
          e.values;
          return r.a.createElement(r.a.Fragment, null, r.a.createElement(F.FormSpy, {
            subscription: {
              values: !0
            },
            onChange: function (e) {
              Object.keys(e.values).length && c(e);
            }
          }), r.a.createElement("div", {
            className: "location-view"
          }, r.a.createElement("div", {
            className: "header"
          }, r.a.createElement("div", {
            className: "location"
          }, r.a.createElement("div", {
            className: "area"
          }, r.a.createElement("h4", {
            className: "name"
          }, t.areas[0].name), t.id === a && r.a.createElement("i", {
            className: "fas fa-star"
          })), r.a.createElement("h6", {
            className: "address"
          }, t.geocode.formatted_address))), r.a.createElement("div", {
            className: "appointment-info"
          }, r.a.createElement("div", {
            className: "available-hours"
          }, r.a.createElement("div", {
            className: "sub-header"
          }, r.a.createElement("h5", {
            className: "title"
          }, "Open Appointment Times"), r.a.createElement("span", {
            className: "desc"
          }, "Times when you are accepting clients.")), r.a.createElement("div", {
            className: "select-items"
          }, (l = {
            morning_availability: "Before 10am",
            daytime_availability: "10am - 1pm",
            evening_availability: "12pm- 5pm",
            afternoon_availability: "After 5pm",
            weekend_availability: "Saturdays & Sundays"
          }, Object.entries(f).map(function (e) {
            var t = Me(e, 2),
              a = t[0],
              n = t[1];
            return r.a.createElement("div", {
              className: "checkbox",
              style: {
                marginBottom: "1rem"
              }
            }, r.a.createElement(F.Field, {
              id: a,
              name: a,
              component: "input",
              type: "checkbox",
              defaultValue: n
            }), r.a.createElement("label", {
              htmlFor: a
            }, r.a.createElement("span", {
              className: "time-of-day"
            }, Object(m.a)(a).replace("_availability", ""))), r.a.createElement("span", {
              className: "hours-of-the-day"
            }, "(", l[a], ")"));
          })))), r.a.createElement("div", {
            className: "regular-hours"
          }, r.a.createElement("div", {
            className: "sub-header"
          }, r.a.createElement("div", {
            className: "content"
          }, r.a.createElement("h5", {
            className: "title"
          }, "Regular Practice Hours"), r.a.createElement("span", {
            className: "desc"
          }, "When you typically see clients.")), r.a.createElement(p, {
            onClick: function () {
              return d(!u);
            },
            primary: !0
          }, "Edit")), r.a.createElement("div", {
            className: "hours"
          }, r.a.createElement(_e, {
            location: Ie({}, t),
            primaryLocationId: a,
            onCancel: function () {
              return d(!1);
            },
            onEdit: function (e) {
              i(e), d(!1);
            },
            onEditValidate: o
          })))), r.a.createElement("div", {
            className: "location-details"
          }, r.a.createElement("h5", {
            className: "sub-header"
          }, "Office Location Details"), r.a.createElement("div", {
            className: "toggle-items"
          }, (n = {
            ada_accessible: "Is this office ADA Accessible?",
            in_home: "Do you offer in-home therapy sessions in this state?",
            remote_location: "Do you offer remote online video sessions in this state?",
            display_address: "Would you like your address displayed on your profile?"
          }, Object.entries(E).map(function (e) {
            var t = Me(e, 2),
              a = t[0],
              l = t[1];
            return r.a.createElement("div", {
              className: "item"
            }, r.a.createElement("span", null, n[a]), r.a.createElement("div", {
              className: "switch"
            }, r.a.createElement(F.Field, {
              id: a,
              name: a,
              component: "input",
              type: "checkbox",
              defaultValue: l
            }), r.a.createElement("label", {
              htmlFor: a,
              className: "md"
            }, r.a.createElement("span", {
              className: "toggle"
            }))));
          }))))));
        }
      });
    },
    Le = function (e) {
      var t = e.onSubmit,
        a = e.validate;
      return r.a.createElement(F.Form, {
        onSubmit: t,
        validate: a,
        render: function (e) {
          var t = e.handleSubmit;
          e.values;
          return r.a.createElement("div", {
            className: "form portal"
          }, r.a.createElement("div", {
            className: "account-preferences"
          }, r.a.createElement("h4", null, "Profile edit request"), r.a.createElement("h6", null, "Send your profile edit updates to the zencare team."), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "Insurances & fees"), r.a.createElement(F.Field, {
            style: {
              resize: "none"
            },
            name: "insuranceFees",
            component: "textarea",
            rows: "3",
            type: "text"
          })), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "Locations"), r.a.createElement(F.Field, {
            style: {
              resize: "none"
            },
            name: "locations",
            component: "textarea",
            rows: "3",
            type: "text"
          })), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "Specialties"), r.a.createElement(F.Field, {
            style: {
              resize: "none"
            },
            name: "specialties",
            component: "textarea",
            rows: "3",
            type: "text"
          })), r.a.createElement("div", {
            className: "field"
          }, r.a.createElement("label", null, "Approach"), r.a.createElement(F.Field, {
            style: {
              resize: "none"
            },
            name: "approach",
            component: "textarea",
            rows: "3",
            type: "text"
          })), r.a.createElement("button", {
            onClick: t,
            className: "primary"
          }, "Submit")));
        }
      });
    },
    Re = function (e) {
      var t = e.link;
      return r.a.createElement("div", {
        className: "form portal refer-a-friend"
      }, r.a.createElement("h4", null, "Refer a Friend"), r.a.createElement("div", {
        className: "container"
      }, r.a.createElement("div", {
        className: "icon"
      }, r.a.createElement("i", {
        className: "fal fa-link"
      })), r.a.createElement("div", {
        className: "link-container"
      }, r.a.createElement("span", null, "Share this link to invite"), r.a.createElement("div", {
        className: "link"
      }, r.a.createElement("input", {
        id: "copyInput",
        value: t,
        type: "input",
        readOnly: !0
      }), r.a.createElement("button", {
        onClick: function () {
          document.getElementById("copyInput").select(), document.execCommand("copy");
        },
        className: "primary"
      }, "Copy")))));
    },
    Ve = function (e) {
      var t = e.onSubmit,
        a = e.onValidate,
        n = e.displayContactForm,
        l = void 0 !== n && n,
        c = e.displayAcuitySchedulingLink,
        i = void 0 !== c && c;
      return r.a.createElement(F.Form, {
        onSubmit: t,
        validate: a,
        render: function (e) {
          var t = e.handleSubmit;
          e.values;
          return r.a.createElement(r.a.Fragment, null, r.a.createElement(F.FormSpy, {
            subscription: {
              values: !0
            },
            onChange: function (e) {
              Object.keys(e.values).length && t(e);
            }
          }), r.a.createElement("div", {
            className: "contact-form"
          }, r.a.createElement("div", {
            className: "form portal"
          }, r.a.createElement("h4", {
            className: "title"
          }, "Contact"), r.a.createElement("div", {
            className: "toggle-items"
          }, r.a.createElement("div", {
            className: "item"
          }, r.a.createElement("h6", null, "Phone Consultation"), r.a.createElement("div", {
            className: "switch"
          }, r.a.createElement(F.Field, {
            id: "display_acuity_scheduling_link",
            name: "display_acuity_scheduling_link",
            component: "input",
            type: "checkbox",
            defaultValue: i
          }), r.a.createElement("label", {
            htmlFor: "display_acuity_scheduling_link"
          }, r.a.createElement("span", {
            className: "toggle"
          })))), r.a.createElement("div", {
            className: "item"
          }, r.a.createElement("h6", null, "Contact Form"), r.a.createElement("div", {
            className: "switch"
          }, r.a.createElement(F.Field, {
            id: "display_contact_form",
            name: "display_contact_form",
            component: "input",
            type: "checkbox",
            defaultValue: l
          }), r.a.createElement("label", {
            htmlFor: "display_contact_form"
          }, r.a.createElement("span", {
            className: "toggle"
          }))))))));
        }
      });
    };
  function He(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function Ue(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var Je = function (e) {
    var t = e.children,
      a = (e.logo, e.id),
      n = e.toggleMobileShow,
      l = e.mobileShow,
      c = Object(m.b)(e);
    return r.a.createElement(r.a.Fragment, null, r.a.createElement("nav", {
      id: a,
      className: "scroll side nav ".concat(c, " ").concat(l ? "show" : "")
    }, t), r.a.createElement("div", {
      className: "overlay ".concat(l ? "" : "hidden"),
      onClick: function () {
        return n();
      }
    }));
  };
  Je.propTypes = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? He(Object(a), !0).forEach(function (t) {
        Ue(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : He(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }({}, Object(m.c)(), {
    logo: s.a.any
  });
  function ze(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function $e(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var Qe = function (e) {
    var t = e.children,
      a = e.id,
      n = Object(m.b)(e);
    return r.a.createElement("nav", {
      id: a,
      className: "nav top ".concat(n)
    }, t);
  };
  Qe.propTypes = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ze(Object(a), !0).forEach(function (t) {
        $e(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ze(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }({}, Object(m.c)(), {
    logo: s.a.any
  });
  function Ke(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function Ge(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ke(Object(a), !0).forEach(function (t) {
        Ze(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Ke(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }
  function Ze(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  function Ye(e, t) {
    if (null == e) return {};
    var a,
      n,
      r = function (e, t) {
        if (null == e) return {};
        var a,
          n,
          r = {},
          l = Object.keys(e);
        for (n = 0; n < l.length; n++) a = l[n], t.indexOf(a) >= 0 || (r[a] = e[a]);
        return r;
      }(e, t);
    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(e);
      for (n = 0; n < l.length; n++) a = l[n], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (r[a] = e[a]);
    }
    return r;
  }
  var Xe = function (e) {
    var t = e.children,
      a = e.icon,
      n = e.href,
      l = e.component,
      c = e.avatar,
      i = e.avatarBefore,
      o = e.linkProps,
      s = void 0 === o ? {} : o,
      u = e.iconProps,
      d = void 0 === u ? {} : u,
      f = Ye(e, ["children", "icon", "href", "component", "avatar", "avatarBefore", "linkProps", "iconProps"]),
      p = Object(m.f)(e),
      b = Object(m.b)(e);
    p.className = "link ".concat(b).trim();
    var E = Object(m.f)(s);
    E.className = Object(m.b)(s);
    var y = a || null;
    if (a && "string" == typeof a) {
      var h = a.match(/(fa\w\s)/i),
        v = h ? h[0].trim() : "fal",
        g = a.replace("".concat(v, " "), "").split(" ").map(function (e) {
          return "fa-".concat(e);
        }).join(" "),
        N = Object(m.f)(d),
        O = Object(m.b)(d);
      N.className = "".concat(v, " ").concat(g, " ").concat(O, " fa-fw").trim(), y = r.a.createElement("i", N);
    }
    if ("boolean" == typeof a) throw TypeError("icon must be a string or a jsx");
    if (n && l) throw TypeError("cannot combine href with custom component");
    var w = Ge({}, f, {}, E),
      j = "span";
    n && (w.href = n, j = "a"), l && (w.activeClassName = "active", j = l);
    var S = r.a.createElement(j, w, t);
    return r.a.createElement("div", p, y, i && (c || null), S, !i && (c || null));
  };
  Xe.propTypes = Ge({}, Object(m.c)(), {
    href: s.a.string,
    icon: s.a.string,
    avatar: s.a.shape(),
    avatarBefore: s.a.bool
  });
  function et(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function tt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? et(Object(a), !0).forEach(function (t) {
        at(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : et(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }
  function at(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var nt = function (e) {
    var t = e.children,
      a = e.title,
      n = Object(m.f)(tt({}, e, {
        title: void 0
      })),
      l = Object(m.b)(e);
    return n.className = "section ".concat(l).trim(), r.a.createElement("div", n, a && r.a.createElement("div", {
      className: "title"
    }, r.a.createElement("small", null, a)), t);
  };
  nt.propTypes = tt({}, Object(m.c)(), {
    title: s.a.string
  });
  function rt(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), a.push.apply(a, n);
    }
    return a;
  }
  function lt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = null != arguments[t] ? arguments[t] : {};
      t % 2 ? rt(Object(a), !0).forEach(function (t) {
        ct(e, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : rt(Object(a)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return e;
  }
  function ct(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  }
  var it = function (e) {
    var t = e.children,
      a = Object(m.f)(lt({}, e)),
      n = Object(m.b)(e);
    return a.className = "dropdown ".concat(n).trim(), r.a.createElement("div", a, t);
  };
  it.propTypes = lt({}, Object(m.c)(), {
    title: s.a.string
  });
}]);